import { render, staticRenderFns } from "./no-result.vue?vue&type=template&id=53cf0c52&scoped=true"
import script from "./no-result.vue?vue&type=script&lang=js"
export * from "./no-result.vue?vue&type=script&lang=js"
import style0 from "./no-result.vue?vue&type=style&index=0&id=53cf0c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf0c52",
  null
  
)

export default component.exports